<div class="body-container">
  <div class="content_header">
    @if (this.factureEnCours()) {
      <div class="facture_loader">
        <span data-text="E" data-text-before=" " class="lettre-masquee">I</span>
        <span data-text="N" data-text-before="D" class="lettre-masquee">I</span>
        <span data-text=" " data-text-before="O" class="lettre-masquee">I</span>
        <span data-text="C" data-text-before="C" class="lettre-masquee">I</span>
        <span data-text="R" data-text-before="U" class="lettre-masquee">I</span>
        <span data-text="E" data-text-before="M" class="lettre-masquee">I</span>
        <span data-text="A" data-text-before="E" class="lettre-masquee">I</span>
        <span data-text="T" data-text-before="N" class="lettre-masquee">I</span>
        <span data-text="I" data-text-before="T" class="lettre-masquee">I</span>
        <span data-text="O" data-text-before=" " class="lettre-masquee">I</span>
        <span data-text="N" data-text-before=" " class="lettre-masquee">I</span>
      </div>
    }
  </div>
  <div class="content_body reddition_body bs_table">
    <app-evenement-filtre class="body-sub-container"></app-evenement-filtre>
    <app-evenements-liste class="body-sub-container"></app-evenements-liste>
  </div>
  <!-- Panneau lateral : `app-drawer` du design system remplace le dispositif
       maison (voile + conteneur coulissant). Il porte son propre voile, son
       animation, la fermeture au clic exterieur et a Echap, et la gestion du
       focus. -->
  @if (voirDetailEvenement() || voirPDF()) {
    <app-drawer ariaLabel="Détail de l'évènement" widthClass="w-[70vw]" (closed)="fermerPanelLateral()">
      @defer (when panelEvenement()) {
        @if (panelEvenement()) {
          <app-panel-evenement-detail></app-panel-evenement-detail>
        }
      }
      <!-- Hors du bloc differe : celui-ci n est declenche que par le chargement du
         DETAIL. Une visionneuse ouverte depuis la liste, sans detail chargé,
         n etait donc jamais rendue. -->
      @if (voirPDF()) {
        <div class="visionneuse_document">
          <div class="visionneuse_header">
            <div class="evt_info">
              <p>{{ panelEvenement()?.idAparte }} {{ panelEvenement()?.nom }}</p>
              du {{ panelEvenement()?.date | date }}
            </div>
            <button type="button" appButton variant="secondary" (click)="voirPDF.set(false)">Fermer</button>
            <button type="button" appButton variant="primary" (click)="telechargerDocumentCourant()">
              Télécharger le document
            </button>
          </div>
          <div class="visionneuse_body">
            <app-pdf-viewer [blob]="pdfCourant()!.content!" [filename]="pdfCourant()!.filename!"></app-pdf-viewer>
          </div>
        </div>
      }
    </app-drawer>
  }
</div>
